import { type DerivedEventFilterLegacy, DerivedEventTypeLegacy } from '@verantos-dev/types-cohorts';

import { getNewCohortBuilderEvent } from './getNewCohortBuilderEvent';

export const getNewEventsForType = (type: DerivedEventTypeLegacy): DerivedEventFilterLegacy[] => {
  switch (type) {
    case DerivedEventTypeLegacy.INSTANCE: {
      return [getNewCohortBuilderEvent(DerivedEventTypeLegacy.INSTANCE)];
    }
    case DerivedEventTypeLegacy.MERGED:
      return [
        getNewCohortBuilderEvent(DerivedEventTypeLegacy.MERGED),
        getNewCohortBuilderEvent(DerivedEventTypeLegacy.MERGED),
      ];
    case DerivedEventTypeLegacy.SEQUENCE: {
      return [
        getNewCohortBuilderEvent(DerivedEventTypeLegacy.SEQUENCE),
        getNewCohortBuilderEvent(DerivedEventTypeLegacy.SEQUENCE, true),
      ];
    }
  }
};
